import React from 'react';
import Verified from '../../domain/Verified';
import Registered from '../../domain/Registered';
import Anonymous from '../../domain/Anonymous';
import get_bundle from '../../domain/get_bundle';
import Color from '../../domain/Color';
import User from '../../domain/User';
import { t, props } from 'tcomb-react';

@props({
  goAccount: t.Func,
  goPurchases: t.Func,
  goChangePassword: t.Func,
  doLogout: t.Func,
  goLogin: t.Func,
  goCatalog: t.maybe(t.Func),
  goLattices: t.maybe(t.Func),
  user: User,
  locale: t.Obj,
  color: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color)
})
export default class Product extends React.Component {

  getColorStyle() {
    if (!this.props.color) {
      return null;
    }
    return {
      color: this.props.color
    };
  };

  styleBtnColor() {
    return {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
  };

  toggle(evt) {
    evt.preventDefault();
    const classes = document.getElementById('actions').className.split(' ');
    if ( classes.indexOf('show') === -1 ) {
      document.getElementById('actions').className = 'large-100 show';
    } else {
      document.getElementById('actions').className = 'large-100 hide';
    }
  }

  goAccount = (evt) => {
    evt.preventDefault();
    this.props.goAccount();
  }

  goPurchases = (evt) => {
    evt.preventDefault();
    this.props.goPurchases();
  }

  goChangePassword = (evt) => {
    evt.preventDefault();
    this.props.goChangePassword();
  }

  doLogout = (evt) => {
    evt.preventDefault();
    this.props.doLogout();
  }

  goLattices = (evt) => {
    evt.preventDefault();
    this.props.goLattices();
  }

  goCatalog = (evt) => {
    evt.preventDefault();
    this.props.goCatalog();
  }

  goLogin = (evt) => {
    evt.preventDefault();
    this.props.goLogin();
  }

  getEmail() {
    if (Anonymous.is(this.props.user)) {
      return (
        //<a href='#' id='go_login' style={this.getColorStyle()} onClick={this.goLogin}>{get_bundle(this.props.locale).login.title}</a>
        <button id='go_login' style={this.styleBtnColor()} onClick={this.goLogin}>{get_bundle(this.props.locale).login.title}</button>
      );
    //  return null;
    }
    return (
      <button id='go_actions' style={this.styleBtnColor()} onClick={this.toggle}><span className="container-email"><span className="email">{this.props.user.email}</span></span></button>
      //<a href='#' id='go_actions' style={this.styleBtnColor()} onClick={this.toggle}><span className="container-email"><span>{this.props.user.email}</span></span></a>
    );
  };

  getDxContent() {
    return (
      <div id="actions" className="large-100 hide">
        <div className="cell">
          <div className="triangle-up"></div>
          { this.getActions() }
        </div>
      </div>
    );
  };

  getActionsForVerified() {
    var navigation_bundle = get_bundle(this.props.locale).navigation;

    return (
      <ul className='nav'>
        <li>
          <a href='#' onClick={this.goAccount}>{navigation_bundle.go_account}</a>
        </li>
        <li>
          <a href='#' onClick={this.goPurchases}>{navigation_bundle.go_purchases}</a>
        </li>
        <li>
          <a href='#' onClick={this.goChangePassword}>{navigation_bundle.go_change_password}</a>
        </li>
        <li className="divider"></li>
        <li>
          <a href='#' onClick={this.doLogout}>{navigation_bundle.do_logout}</a>
        </li>
      </ul>);
  }

  getActionsForRegistered() {
    var navigation_bundle = get_bundle(this.props.locale).navigation;

    return (
      <ul className='nav'>
        <li>
          <a href='#' onClick={this.goPurchases}>{navigation_bundle.go_purchases}</a>
        </li>
        <li>
          <a href='#' onClick={this.goChangePassword}>{navigation_bundle.go_change_password}</a>
        </li>
        <li className="divider"></li>
        <li>
          <a href='#' onClick={this.doLogout}>{navigation_bundle.do_logout}</a>
        </li>
      </ul>
    );
  }

  getActions() {
    if (Anonymous.is(this.props.user)) {
     return null;
    }

    if (Verified.is(this.props.user)) {
      return this.getActionsForVerified();
    }
    else if (Registered.is(this.props.user)) {
      return this.getActionsForRegistered();
    }
  };

  getGoLatticesLink() {
    if (!this.props.goLattices) {
      return null;
    }

    //return (<a href='#' id='go_lattices' style={this.getColorStyle()} onClick={this.goLattices}>{get_bundle(this.props.locale).navigation.go_lattices}</a>);
    return (<button id="go_lattices" onClick={this.goLattices} style={this.styleBtnColor()}>{get_bundle(this.props.locale).navigation.go_lattices}</button>)
  }

  getGoCatalogLink() {
    if (!this.props.goCatalog) {
      return null;
    }
    let style = {
      ...this.styleBtnColor()
    }

    if (this.props.goLattices) {
      style.marginLeft = '20px'
    }
    //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</a>);
    return (<button id='go_catalog' style={style} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</button>);
  }

  render() {

    return (
      <div id='header'>
        <div className='cols'>
          <div className='large-70'>
            <div className='cell'>
              {this.getGoLatticesLink()}
              {this.getGoCatalogLink()}
            </div>
          </div>
          <div className='large-30 large-text-right'>
            <div className='cell'>
              {this.getEmail()}
            </div>
          </div>
          {this.getDxContent()}
        </div>
      </div>
    );
  }

}





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/header/Product.js
 **/